import React from "react";
import styles from "./styles.module.css";

const TicketHeader = ({ ticketDetails, exitEditMode, changeTicketDetails }) => {
  const { id, date } = ticketDetails;

  return (
    <div className={`${styles.ticketHeader} p-2`}>
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <div className="d-flex align-items-center">
            <i className="fas fa-edit" style={{ color: "#0891b2" }}></i>

            <span className={`${styles.headerText} text-bold ml-1`}>
              Editing Student Information
            </span>
          </div>
          <div className="text-sm ml-2" style={{ color: "#0e7490" }}>
            Ticket:{id} | Date: {date}
          </div>
        </div>
        <div className="d-flex align-items-center">
          <button
            className={styles.changeTicketBtn}
            onClick={changeTicketDetails}
          >
            Change Ticket
          </button>
          <button className={styles.exitModeBtn} onClick={exitEditMode}>
            Exit Edit Mode
          </button>
        </div>
      </div>
    </div>
  );
};

export default TicketHeader;
